// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_GNe","cls2":"ReferenceEvaluationPage-cls2_wdl ReferenceEvaluationPage-cls1_GNe"};